import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContext } from "../../../hooks/context";
import { useMutation } from "react-query";
import { generateWaybill } from "../../../services/sales-point";
import { pathConstants } from "../../../routes/pathContants";

const useWayBillFormV2 = () => {
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);
  const [selected, setSelected] = useState({});
  const [waybillQty, setWaybillQty] = useState({});
  const { business_phone_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const [orderData, setOrderData] = useState({
    order_id: "",
    items: [],
    delivery_address: "",
    driver_name: "",
    driver_number: "",
    phone_number: "",
    delivery_company: "",
    phone_code: "",
  });
  const allSelected =
    orderData.items.length > 0 &&
    orderData.items.every((item) => selected[item.item_id]);
  const someSelected =
    orderData.items.some((item) => selected[item.item_id]) && !allSelected;

  const toggleItem = (id) => {
    setSelected((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleAll = () => {
    if (allSelected) {
      setSelected({});
    } else {
      const newSelection = {};
      orderData.items.forEach((item) => {
        newSelection[item?.item_id] = true;
      });
      setSelected(newSelection);
    }
  };

  const generateWaybillMutation = useMutation({
    mutationFn: (data) => generateWaybill(orderData?.order_id, data),
    onSuccess: (response) => {
      triggerToast("Waybill Generated Successfully", "success");
      navigate(pathConstants.PROCUREMENT_WAYBILLS);
    },
  });

  const handleGenerateWaybill = () => {
    const payload = {
      waybill_items:
        orderData?.items
          .filter((item) => selected[item?.item_id])
          .map((item) => ({
            item_id: item?.item_id,
            quantity: waybillQty[item.item_id] || 0,
          })) || [],
      customer: {},
      logistics: {
        driver_name: orderData?.driver_name,
        driver_vehicle_number: orderData?.driver_number,
        driver_phone_number: orderData?.phone_number,
        driver_phone_code: orderData?.phone_code || business_phone_code,
        company: orderData?.delivery_company,
        delivery_address: orderData?.delivery_address,
      },
    };

    generateWaybillMutation.mutate(payload);
  };

  return {
    navigate,
    orderData,
    setOrderData,
    selected,
    waybillQty,
    toggleItem,
    toggleAll,
    someSelected,
    allSelected,
    setWaybillQty,
    handleGenerateWaybill,
    generateWaybillMutation,
  };
};

export default useWayBillFormV2;
